import { CreateAccount } from "@/types/auth";
import config from "@/configs";

export const getConnectAccountToken = (data: CreateAccount): any => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const stripe = Stripe(config?.stripe.pubKey);
  const payload = {
    account: data,
  };

  return stripe.createToken("account", payload);
};
